<script lang="ts">
  import type { BulkClassStudentUpdateAction } from '$lib/api/types';
  import type { SvelteSet } from 'svelte/reactivity';
  import ClinicalGroupQuickSearch from '../common/ClinicalGroupQuickSearch.svelte';
  import FormModal from '../common/modal/FormModal.svelte';
  import Label from '../common/bootstrap/Label.svelte';
  import { studentBulkAction } from '$lib/api/classes';
  import { toast } from '$lib/stores/toast.svelte';

  interface Props {
    action: BulkClassStudentUpdateAction | null;
    classId: number;
    students: SvelteSet<number>;
  }
  let { action = $bindable(), classId, students }: Props = $props();

  let clinicalGroupValue: string | null = $state(null);
  let clinicalGroupTouched = $state(false);
</script>

<FormModal
  formId="bulk_action_confirm"
  onclose={() => (action = null)}
  header={action === 'Remove' ? 'Remove selected students?' : 'Assign selected students to clinical group'}
  invalidateUrl={url => url.pathname.startsWith('/api/classes')}
  scrollable={false}
  submitBtnLabel={action === 'Remove' ? `Remove ${students.size} student(s)` : 'Save'}
  validationChecks={() => {
    if (action === 'AssignClinicalGroup') {
      clinicalGroupTouched = true;
      return clinicalGroupValue !== null;
    }
    return true;
  }}
  onsubmit={async () => {
    const { affectedRows } = await studentBulkAction(classId, {
      studentIds: Array.from(students),
      action: action!,
      parameters:
        action === 'AssignClinicalGroup'
          ? {
              newClinicalGroupId: parseInt(clinicalGroupValue!),
            }
          : undefined,
    });
    toast.showToast(
      'success',
      action === 'Remove'
        ? `Removed ${affectedRows} student(s) from the class`
        : `Updated clinical group of ${affectedRows} student(s)`,
    );
    return true;
  }}
>
  <p>
    {#if action === 'Remove'}
      Remove selected students from class? Students will be removed from the class leaderboard. They will no longer be 
      able to view the class or log skills.
    {:else}
      Please choose a clinical group to assign the selected students.
    {/if}
  </p>
  {#if action === 'AssignClinicalGroup'}
    <Label for="bulk_assign_clinical_group">Choose Clinical Group</Label>
    <ClinicalGroupQuickSearch
      id="bulk_assign_clinical_group"
      {classId}
      required
      bind:value={clinicalGroupValue}
      bind:touched={clinicalGroupTouched}
    />
  {/if}
</FormModal>
